import { FC } from 'react';
import { css } from '@linaria/core';
import { useCopyToClipboard } from 'react-use';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { PlaygroundAssistantMessage } from '../store/messageStore';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { TooltipWrapper } from './TooltipWrapper';
import SvgCopy02Sm from './Icons/Copy02Sm';
interface ChatMessageActionBarProps {
  message: PlaygroundAssistantMessage;
  isLastMessage: boolean;
  values: PlaygroundConfig;
}
export const ChatMessageActionBar: FC<ChatMessageActionBarProps> = ({
  isLastMessage,
  message,
  values
}) => {
  const [, copyToClipboard] = useCopyToClipboard();
  const {
    displayPlaygroundTokenStatLDFF
  } = useFeatureFlagsLD();
  const durationInSeconds = message.endTime && message.startTime ? (message.endTime - message.startTime) / 1000 : 0;
  const tokensPerSecond = message.outTokens && durationInSeconds ? message.outTokens / durationInSeconds : 0;
  const handleCopyClick = () => {
    copyToClipboard(message.content);
    cogoToast.success('Message copied to clipboard!');
  };

  // Check if the feature flag for displaying token stats is enabled
  // If the feature flag is disabled, do not render the action bar
  if (!displayPlaygroundTokenStatLDFF) return null;
  return <>
      {!isLastMessage || !values.isStreaming && !values.isOutputLoading ? <div className={MessageActionBarStyle}>
          <TooltipWrapper toolTipText="Copy Message" side="top">
            <button type="button" onClick={handleCopyClick} className="copy-button">
              <SvgCopy02Sm className={copyButton} />
            </button>
          </TooltipWrapper>
          {message.inTokens && message.outTokens && tokensPerSecond ? <div className={TokenStatsStyle}>
              <code>{message.inTokens} IN</code>
              <code>{message.outTokens} OUT</code>
              <code>{Math.round(tokensPerSecond * 100) / 100} TOKENS/S</code>
            </div> : null}
        </div> : null}
    </>;
};
const MessageActionBarStyle = "odules__Playground__Components__ChatMessageActionBar_tsx-MessageActionBarStyle-m1mf44rs";
const TokenStatsStyle = "odules__Playground__Components__ChatMessageActionBar_tsx-TokenStatsStyle-t539ct7";
const copyButton = "odules__Playground__Components__ChatMessageActionBar_tsx-copyButton-c1d8iidu";

require("./ChatMessageActionBar.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ChatMessageActionBar.tsx");